<template>
  <div :class="classes">
    <label :class="labelClasses" v-if="label"><span class="required" v-if="required">*</span>{{label}}</label>

    <div :class="inputOrientationClasses">
      <slot></slot>
      <span class="help-block" v-if="state=='error'">{{help}}</span>
    </div>
  </div>
</template>
<style>
  @media (min-width: 992px) {
    .form-group.form-group-horizontal .control-label{
      text-align: right;
      margin-bottom: 0;
      padding-top: 7px;
    }
  }
  .required {
     margin-right:4px;
  }
</style>
<script>
  export default{
    name: 'Formbox',
    props: {
      required: {type: Boolean, default: false},
      label: {type: String},
      labelWidth: {type: Number, default: 0},
      state: {type: String, default: '', validator: value => ['','success', 'warning', 'error'].indexOf(value) > -1},
      help: {type: String},
      horizontal: {type: Boolean},
      klass: {type: String}
    },
    computed: {
      classes () {
        return [
          {'form-group row': true},
          {'form-group-horizontal': !!this.horizontal},
          {[`has-${this.state}`]: !!this.state},
          {[this.klass]: !!this.klass}
        ]
      },
      labelClasses () {
        let width = {}
        if (this.labelWidth>0) {
           width['col-md-' + this.labelWidth] = !!this.horizontal
        } else {
           width = {'col-md-4': !!this.horizontal}
        }
        return [
          {'control-label': true},
          {'col-md-12': !this.horizontal},
          width
        ]
      },
      inputOrientationClasses () {
        let width = {}
        if (this.labelWidth>0) {
           width['col-md-' + (12 - this.labelWidth)] = !!this.horizontal
        } else {
           width = {'col-md-8': !!this.horizontal}
        }
        return [
          {'col-md-12': !this.horizontal},
          width
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// formbox.vue?176e0cd8